export const GET_CURRENT_USER_BEGIN = "GET_CURRENT_USER_BEGIN";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";

export const SET_OFFERING_MODEL = "SET_OFFERING_MODEL";
export const SET_OFFERING_CLASS = "SET_OFFERING_CLASS";

export const SET_ASSET_CLASS_SEARCH = "SET_ASSET_CLASS_SEARCH";
